module.exports = __webpack_public_path__ + "media/images/flags/16/Saint-Kitts-and-Nevis-b209435c2c09941e983b89fe0defc867.png";